import PropTypes from 'prop-types'
import React from 'react'
import SelectField from './SelectField'
import { dataToOptions } from '../../../utils/helpers'
import AutocompleteField from './AutocompleteField'
import useInstitutionType from '../../../hooks/useInstitutionType'
import useInstitution from '../../../hooks/useInstitution'
import useMunicipality from '../../../hooks/services/useMunicipality'
import useFieldValue from '../../../hooks/useFieldValue'

const InstitutionTypeFieldFilter = ({ name, label, showInstitutions = false, showMunicipalityType = false }) => {
  const selectedInstitutionType = useFieldValue(`${name}_institution_type`)

  const { getInstitutionTypes } = useInstitutionType()
  const { data: institutionTypes } = getInstitutionTypes()
  const { getInstitutions } = useInstitution()
  const { data: institutions } = getInstitutions(selectedInstitutionType)

  const { getMunicipalityTypes } = useMunicipality()
  const { data: municipalityTypes } = getMunicipalityTypes(
    ['municipality_type', selectedInstitutionType],
    { institution_type: selectedInstitutionType },
    { enabled: showMunicipalityType && Boolean(selectedInstitutionType), initialData: [] }
  )
  const municipalityTypesOptions = municipalityTypes.map(t => ({ value: t, label: t }))

  const defaultInstitutionOption = {
    label: 'Selecciona una entidad',
    value: ''
  }

  return (
    <div className="flex flex-col gap-6 mb-4">
      <SelectField
        className="w-full mt-3"
        label={label || 'Tipo de entidad'}
        name={`${name}_institution_type`}
        margin="none"
        size="full"
        emptyLabel="Todos"
        options={dataToOptions(institutionTypes)}
      />

      {showMunicipalityType && (
        <SelectField
          className="w-full"
          parentClassName="-mb-0.5"
          label="Subtipo de entidad"
          name={`${name}_municipality_type`}
          margin="none"
          size="full"
          options={municipalityTypesOptions}
          disabled={!selectedInstitutionType || municipalityTypesOptions.length === 0}
        />
      )}

      {showInstitutions && (
        <AutocompleteField
          className="w-full"
          labelClassName="mb-2"
          label="Entidad"
          name={`${name}_institution_id`}
          margin="none"
          size="full"
          emptyLabel="Todas"
          options={[defaultInstitutionOption, ...dataToOptions(institutions)]}
        />
      )}
    </div>
  )
}

export default InstitutionTypeFieldFilter

InstitutionTypeFieldFilter.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  showInstitutions: PropTypes.bool,
  showMunicipalityType: PropTypes.bool
}
